import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useIsMobile } from "src/hooks/useIsMobile";
import { ContentFrame } from "src/styles";
// import { ServiceTypeItem } from "src/types";
import ServiceTypeQuestion from "../../ServiceTypeQuestion";
import { UploadWorkOrderAttachments } from "../../UploadWorkOrderAttachments";
import { Container, Content, InputsContainer, PhotoInput, StyledForm } from "../styles";
import { NoAuthCreateFormFieldsProps } from "../types";
import CreateFormButtonContainer from "./CreateFormButtonContainer";
import { CustomWorkRequestFieldsForm } from "./CustomWorkRequestFieldsForm";
import WorkRequestCommentInput from "./WorkRequestCommentInput";
import WorkRequestDescriptionInput from "./WorkRequestDescriptionInput";
import WorkRequestNameInput from "./WorkRequestNameInput";
import WorkRequestSelectLocation from "./WorkRequestSelectLocation";
import WorkRequestSelectWorkTypeDropdown from "./WorkRequestSelectWorkTypeDropdown";
import WorkRequestServiceTypeSelectSearch from "./WorkRequestServiceTypeSelectSearch";
import WorkRequestTargetDatesInput from "./WorkRequestTargetDatesInput";

const NoAuthCreateFormFields = ({
  formData,
  isVerifyMode,
  setFormData,
  clientId,
  locations,
  serviceTypes,
  workTypes,
  setServiceTypeId,
  serviceTypeId,
  serviceTypeQuestions,
  customWorkRequestFields,
  form,
  setFiles,
  files,
  setTimezone,
  noAuthData,
  maximoTimezone,
  targetFinish,
  targetStart,
  timezone,
  buttonDisabledConditions,
  error,
  isLoading,
  onConfirmClick,
  onSubmit,
  setIsVerifyMode,
}: NoAuthCreateFormFieldsProps) => {
  const { isMobile } = useIsMobile();

  return (
    <Container>
      <Content>
        <ContentFrame>
          <StyledForm>
            <InputsContainer $isMobile={isMobile}>
              <WorkRequestNameInput
                isVerifyMode={isVerifyMode}
                setFormData={setFormData}
                ticketName={formData.ticketName}
              />
              <WorkRequestServiceTypeSelectSearch
                disabled={false}
                clientId={clientId}
                isManager={false}
                isVerifyMode={isVerifyMode}
                noAuthServiceList={noAuthData?.serviceTypes?.serviceTypes}
                serviceType={formData.serviceType}
                serviceTypeId={serviceTypeId}
                setFormData={setFormData}
                setServiceTypeId={setServiceTypeId}
                serviceTypes={serviceTypes}
                workTypes={workTypes}
              />

              <ReactTooltip className="tooltip" />
              <WorkRequestSelectWorkTypeDropdown
                isVerifyMode={isVerifyMode}
                setFormData={setFormData}
                workTypes={workTypes}
              />
              <WorkRequestSelectLocation
                clientId={clientId}
                isVerifyMode={isVerifyMode}
                setFormData={setFormData}
                setTimezone={setTimezone}
                locations={locations}
              />
            </InputsContainer>
            {!!serviceTypeQuestions.length &&
              serviceTypeQuestions.map((el) => (
                <ServiceTypeQuestion
                  key={el.id}
                  question={el}
                  formData={formData}
                  setFormData={setFormData}
                  disabled={isVerifyMode}
                />
              ))}
            <WorkRequestDescriptionInput
              description={formData.description}
              isVerifyMode={isVerifyMode}
              setFormData={setFormData}
            />

            <WorkRequestCommentInput
              comment={formData.workRequestComment}
              isVerifyMode={isVerifyMode}
              setFormData={setFormData}
            />

            {customWorkRequestFields && (
              <CustomWorkRequestFieldsForm
                customWorkRequestFields={customWorkRequestFields[clientId] ?? []}
                $isMobile={isMobile}
                form={form}
                isPublic={true}
                isClient={false}
              />
            )}
            {isVerifyMode && files?.length === 0 ? null : (
              <PhotoInput>
                <UploadWorkOrderAttachments setFiles={setFiles} files={files} isViewMode={isVerifyMode} />
              </PhotoInput>
            )}
            <WorkRequestTargetDatesInput
              isVerifyMode={isVerifyMode}
              maximoTimezone={maximoTimezone}
              targetFinish={targetFinish}
              targetStart={targetStart}
              timezone={timezone}
              showTopLine={files?.length === 0 ? 1 : 0}
            />
            <CreateFormButtonContainer
              error={error}
              buttonDisabledConditions={buttonDisabledConditions}
              isLoading={isLoading}
              isVerifyMode={isVerifyMode}
              onConfirmClick={onConfirmClick}
              onSubmit={onSubmit}
              setIsVerifyMode={setIsVerifyMode}
            />
          </StyledForm>
        </ContentFrame>
      </Content>
    </Container>
  );
};

export default NoAuthCreateFormFields;
